module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Neuigkeiten_ro.ff79d1e9.jpg";